import { Component, AfterViewInit, ViewChild, Input,ElementRef, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatTableDataSource } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { merge, Observable, of as observableOf, Subject } from 'rxjs';
import { catchError, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MessageService } from 'src/app/services/message/message.service';
import { FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { CoreServiceService } from 'src/app/services/core/core-service.service';
import { environment } from 'src/environments/environment';
import { ProfileComponent } from 'src/app/pages/profile/profile.component';


export interface searchFilter {
  transmitter: string;
  recipient: string;
  projectId: string;
  dateBefore: any;
  dateDeadline: any;
  dateDeadlineAfter: any;
  dateAfter: any;
  tag: string;
  copy?: string;
  statut: boolean;
  type: string;
  keyWord: string;
  smartNumber: string,
  isGeneral?: any,
  isThematic?: any,
  isTask?: any,
  isReadAnswer?: any
}

@Component({
  selector: 'app-dashboardsuivi',
  templateUrl: './dashboardsuivi.component.html',
  styleUrls: ['./dashboardsuivi.component.scss']
})

export class DashboardsuiviComponent implements AfterViewInit, OnDestroy, OnInit {
 
  messages: any = [];
  dataSource: any;
  resultsLength = 0;
  perPage = 30;
  isLoadingResults = false;
  isRateLimitReached = false;
  lastDate = new Date('01/01/4970');
  filterChoosen = null;
  firstLoad = true;

  displayedColumns: string[] = [
    'Date',
    'Projet',
    //'Type',
    'Sous-canal',
    'Expéditeur',
    'Destinataire',
    'Statut',
    'consult'
  ];
  
  hiddenSearchEngin = true;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('journalWrapper', { static: false }) journalWrapper: ElementRef;

  @Output() EventLaunchSearch = new EventEmitter();
  @Output() EventLaunchSearchDoc = new EventEmitter();
  @Output() EventLaunchFilter = new EventEmitter();
  @Input() ged: boolean = false;

  transmitter = null;
  recipient = null;
  projectId = null;
  dateBefore = null;
  dateAfter = null;
  dateDeadline = null;
  dateDeadlineAfter = null;
  tag = null;
  statut = null;
  copy = null;
  type = null;
  typebloc = null;
  keyWord = null;
  smartNumber = null;
  isGeneral = null;
  isThematic = null;
  statusMsg = null;
  isTask = null;
  isReadAnswer = null;
  modeDoc = false;
  //contacts: Array<any> = [];
  contactsExp: Array<any> = [];
  contactsDest: Array<any> = [];
  projectLists: Array<any> = [];
  projectTags: any;
  chosenFilter: searchFilter;
  currentUser = null;
  saveCtc = null;
  saveCtcTransmitter = null;
  saveProject = null;
  saveTheme   = null;
  secteur = "";
  hideNav = Number(localStorage.getItem('hideNav'));
  public transmitterCtrl: FormControl = new FormControl();
  public recipientCtrl: FormControl = new FormControl();
  public projectCtrl: FormControl = new FormControl();
  public themeCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  recentProject = null;
  searchstepface = "init";
  searchsenderface = "Éxpéditeur";
  searchrecipientface = "Destinataire";
  searchcopyface = "Membre en Copie";
  searchthemeface = "Canal";
  searchtypeface = "Type de Document";
  searchtypebloc = "Type de bloc";
  searchproject = "Client";
  searchdateface = "Face";
  searchstatusface = "Statut des faces";
  searchnumface = "Numéro du face";
  searchtypes = [];
  searchtypesblocs = [];
  searchtypesfilter = [
    {id: "pdf", nom: "Pdf", image: "search-pdf"},
    {id: "excel", nom: "Excel", image: "search-excel"},
    {id: "word", nom: "Word", image: "search-word"},
    {id: "presentation", nom: "Présentation", image: "search-presentation"},
    {id: "image", nom: "image", image: "search-image"},
    {id: "video", nom: "Vidéo", image: "search-video"},
    {id: "http", nom: "Lien", image: "search-lien"}
  ]
  searchtypesApi = [];
  filterprojectf = "alpha";
  filtersenderf = "alpha";
  filterrecipientf = "alpha";
  filtertagf = "alpha";
  searchProjectF = null;
  searchSenderF = null;
  searchRecipientF = null;
  searchCopyF = null;
  searchTagF = null;
  projectInit = [];
  projectSendersInit = [];
  searchRecipientInit = [];
  searchCopyInit = [];
  searchSenderInit = [];
  searchTagInit = [];
  searchTags = [];
  searchresLength = 0;
  targetValue: number = 0;
  intervalId: any;
  private refreshSearchObs = new Subject();
  filterChoosenSearch= null;
  name: string;
  profile: string;
  commonRef: string;
  
  currentPage = 1;
  Math = Math;
  //statusanswered = true;
  //statusnotanswered = true;
  vibrantColors = [
    "#FF5733", // Rouge vif
    "#FF8D1A", // Orange vif
    "#F9C74F", // Jaune doré
    "#4CAF50", // Vert
    "#D32F2F", // Rouge profond
    "#9C27B0", // Violet
    "#E91E63", // Rose
    "#FFEB3B", // Jaune
    "#00BCD4", // Bleu clair
    "#8BC34A", // Vert lime
    "#FF5722", // Orange foncé
    "#3F51B5", // Bleu indigo
    "#9E9D24", // Jaune-vert
    "#F44336", // Rouge éclatant
    "#00C853", // Vert vif
    "#9E1B32", // Rouge sombre
    "#F50057", // Rose fuchsia
    "#FF7043", // Orange corail
    "#8E24AA", // Violet intense
    "#388E3C"  // Vert forêt
  ];
  notified = false;
  isTaskMode = null;
  sentNotif = 0;
  receivedNotif = 0;
  incopyNotif = 0;
  commentNotif = 0;
  statusSelected = 0;
  typenotif = "sent";
  private destroy$ = new Subject<void>();


  constructor(private location: Location, public dialog: MatDialog, private coreService: CoreServiceService, private authService: AuthService, private router: Router, private route: ActivatedRoute, private messageService: MessageService) { 
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    delete currentUser.token;
    delete currentUser.refresh_token;
    delete currentUser.roles;
    this.currentUser = currentUser;
    this.route.queryParams.subscribe(params => {
      this.recentProject = params['projet'];
    });
  }

  // état d'ouverture du menu principal
  showStatutMenu = false;

  // sous-menu actif : 'taches' | 'messages' | null
  activeSubMenu: string | null = null;

  selectedStatus: string = null;

  toggleStatutMenu(): void {
    this.showStatutMenu = !this.showStatutMenu;
    if (!this.showStatutMenu) {
      this.activeSubMenu = null;
    }
  }

  openSubMenu(type: string, event: Event): void {
    event.stopPropagation();
    this.activeSubMenu = this.activeSubMenu === type ? null : type;
  }

  chooseStatus(value: string): void {
    this.selectedStatus = value;
    this.showStatutMenu = false;
    this.activeSubMenu = null;
    // ici tu peux émettre un event vers le parent, appeler un service, etc.
    console.log('Statut choisi :', value);
  }

  // ferme le menu si on clique en dehors
  closeAll(): void {
    console.log("cliqued")
    this.showStatutMenu = false;
    this.activeSubMenu = null;
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(){
    this.authService.setMode('cooperatif');
    this.resultsLength = 0; 
    this.searchresLength = 0;
    this.secteur = localStorage.getItem('secteur');
  
    /*this.getContact();
    this.loadProject(); 
    this.loadTypesBlocs();
    this.loadTypes();*/
    //this.selectDefaultStatusFace('sent');
    this.authService.getGlobalNotification().subscribe(res => {
        this.sentNotif = res['hydra:member']['sent'];
        this.receivedNotif = res['hydra:member']['receive'];
        this.incopyNotif = res['hydra:member']['copy'];
        this.commentNotif = res['hydra:member']['comment'];
        this.selectDefaultTab();
    })

    this.authService.obreceiveMessage.subscribe((res) =>{
        this.authService.getGlobalNotification().subscribe(res => {
          this.sentNotif = res['hydra:member']['sent'];
        this.receivedNotif = res['hydra:member']['receive'];
        this.incopyNotif = res['hydra:member']['copy'];
        this.commentNotif = res['hydra:member']['comment'];
        })
    });

    this.authService.closeBloc.subscribe((term) =>{ 
      if(term == 1){
        this.resetSearch();
      }
    });
    this.authService.obprojectChosen.subscribe((idMessage) =>{ 
      this.smartNumber = idMessage;
    });

    this.authService.changeModeProject
    .pipe(takeUntil(this.destroy$))
    .subscribe(res => {
      if (res === 'change') {
        this.redirectToHistoInstant();
      }
    });

    this.coreService.toggleSidebar.subscribe((res) => {
      this.hideNav = Number(res);
    });

    this.ged = false;
    this.hiddenSearchEngin = true;

  }

  getStatut(element: any): { isDepasse: boolean, nbJours?: number } {
    const today = new Date();

    if (!element.deadline) {
      return { isDepasse: false };
    }

    const deadlineDate = new Date(element.deadline);

    if (deadlineDate > today) {
      return { isDepasse: false };
    }

    const diffTime = today.getTime() - deadlineDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));

    return { isDepasse: true, nbJours: diffDays };
  }

  getRestDays(element: any): { isDepasse: boolean, nbJours?: number } {
    const today = new Date();

    if (!element.deadline) {
      return { isDepasse: false };
    }

    const deadlineDate = new Date(element.deadline);

    const diffTime = deadlineDate.getTime() - today.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));

    return { isDepasse: false, nbJours: diffDays };
  }

  selectDefaultTab(): void {
    console.log("sent : "+this.sentNotif)
    console.log("received : "+this.receivedNotif)
    console.log("incopy : "+this.incopyNotif)
    console.log("comment : "+this.commentNotif)
    if (this.sentNotif >= this.receivedNotif && this.sentNotif > 0) {
      this.selectDefaultStatusFace('sent');
    } else if (this.receivedNotif >= this.sentNotif && this.receivedNotif > 0) {
      this.selectDefaultStatusFace('received');
    } else if (this.sentNotif === 0 && this.receivedNotif === 0 && this.incopyNotif > 0) {
      this.selectDefaultStatusFace('incopy');
    } else {
      this.selectDefaultStatusFace('comment');
    }
  }




  calculateDate(date) {
    var result = 0;
    var today = new Date().setHours(0, 0, 0, 0);
    var yesterday = new Date(new Date().setDate(new Date().getDate()-1)).setHours(0, 0, 0, 0);
    date = new Date(date);
    if (date >= today) {
      result = 1;
    } else if (date >= yesterday) {
      result = 2;
    } else result = 3;
    return result;
  }

  initFilterProject(){
    this.EventLaunchFilter.emit('all');
  }

  redirectToHistoInstant(){
    this.router.navigate(['/dashboardsuiviinst']);
  }

  ngAfterViewInit() {  

    this.recipientCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterRecipient();
      });

    this.transmitterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterTransmitter();
    });


    this.projectCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterProject();
      });

    this.themeCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.themeProject();
      });
   

  }



 loadFilterElement(){
    //console.log("on loadFilterElement");
    if (this.firstLoad == true) {
      this.getContact();
      this.loadProject();
      this.loadTypes();
    }
    this.firstLoad = false;
  }

  fcthiddenSearchEngin(){
      this.searchstepface = "init";
    if (this.hiddenSearchEngin == false){
      this.hiddenSearchEngin = true;
    } else
      this.hiddenSearchEngin = false;
  }

  protected filterRecipient() {
    if(this.saveCtc == null){
      this.saveCtc = this.contactsDest;
    }

    let search = this.recipientCtrl.value;
    if (!search) {
      this.contactsDest = this.saveCtc;
      return;
    } else {
      search = search.toLowerCase();
      this.contactsDest = this.saveCtc.filter(bank => bank.givenName.toLowerCase().indexOf(search) > -1 || bank.familyName.toLowerCase().indexOf(search) > -1 );
    }
  }

  protected filterTransmitter(){
    if(this.saveCtcTransmitter == null){
      this.saveCtcTransmitter = this.contactsExp;
    }

    let search = this.transmitterCtrl.value;
    if (!search) {
      this.contactsExp = this.saveCtcTransmitter;
      return;
    } else {
      search = search.toLowerCase();
      this.contactsExp = this.saveCtcTransmitter.filter(bank => bank.givenName.toLowerCase().indexOf(search) > -1 || bank.familyName.toLowerCase().indexOf(search) > -1 );
    }
  }

  protected filterProject() {
    if(this.saveProject == null){
      this.saveProject = this.projectLists;
    }

    let search = this.projectCtrl.value;
    if (!search) {
      this.projectLists = this.saveProject;
      return;
    } else {
      search = search.toLowerCase();
      this.projectLists = this.saveProject.filter(bank => bank.libelle.toLowerCase().indexOf(search) > -1);
    }
  }

  protected themeProject() {
    // console.log("calling themeProject");
    if(this.saveTheme == null){
      this.saveTheme = this.projectTags;
      // console.log("in themeProject", this.saveTheme);
    }else{
      // console.log("else themeProject", this.projectTags);
    }

    let search = this.themeCtrl.value;
    if (!search) {
      this.projectTags = this.saveTheme;
      return;
    } else {
      search = search.toLowerCase();
      this.projectTags = this.saveTheme.filter(bank => bank.libelle.toLowerCase().indexOf(search) > -1);
    }
  }

  onSearchProjectF() {
    if (this.searchProjectF.trim() === '' || this.searchProjectF == null) {
      this.searchProjectF = null;
      this.projectInit = this.projectLists;
      this.filterProjectF(this.filterprojectf);
    } else {
      var search = this.searchProjectF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.projectInit = this.projectLists.filter(bank => bank.libelle.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1);
    }
  }

  onSearchSenderF() {
    if (this.searchSenderF.trim() === '' || this.searchSenderF == null) {
      this.searchSenderF = null;
      this.searchSenderInit = this.contactsExp;
      this.filterSendersF(this.filtersenderf);
    } else {
      var search = this.searchSenderF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchSenderInit = this.contactsExp.filter(bank => bank.fullName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  onSearchRecipientF() {
    if (this.searchRecipientF.trim() === '' || this.searchRecipientF == null) {
      this.searchRecipientF = null;
      this.searchRecipientInit = this.contactsDest;
      this.filterRecipientF(this.filterrecipientf);
    } else {
      var search = this.searchRecipientF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchRecipientInit = this.contactsDest.filter(bank => bank.fullName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  onSearchTagF() {
    if (this.searchTagF.trim() === '' || this.searchTagF == null) {
      this.searchTagF = null;
      this.searchTagInit = this.searchTags;
      this.filterTagF(this.filtertagf);
    } else {
      var search = this.searchTagF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchTagInit = this.searchTags.filter(bank => bank.libelle.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1);
    }
  }

  //************* */
  filterProjectF(val : any){
    this.filterprojectf = val;
    if(val == "date"){
        this.projectInit.sort((a, b) => {
          if ( a.lastface > b.lastface ){
            return -1;
          }
          if ( a.lastface < b.lastface ){
            return 1;
          }
          return 0;
        })
    } else {
      this.projectInit.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  getRandomColor(): string {
    const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
    return this.vibrantColors[randomIndex];
}

  getInitials(libelle: string): string {
    const words = libelle.split(' ');
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point

    return initials;
  }

  filterSendersF(val : any){
    this.filterSendersF = val;
    if(val == "date"){
        this.searchSenderInit.sort((a, b) => {
          if ( a.user.createdAt > b.user.createdAt ){
            return -1;
          }
          if ( a.user.createdAt < b.user.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.searchSenderInit.sort((a, b) => {
        if ( a.user.fullName.toLowerCase() < b.user.fullName.toLowerCase() ){
          return -1;
        }
        if ( a.user.fullName.toLowerCase() > b.user.fullName.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  filterRecipientF(val : any){
    this.filterRecipientF = val;
    if(val == "date"){
        this.searchRecipientInit.sort((a, b) => {
          if ( a.user.createdAt > b.user.createdAt ){
            return -1;
          }
          if ( a.user.createdAt < b.user.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.searchRecipientInit.sort((a, b) => {
        if ( a.user.fullName.toLowerCase() < b.user.fullName.toLowerCase() ){
          return -1;
        }
        if ( a.user.fullName.toLowerCase() > b.user.fullName.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  filterTagF(val : any){
    this.filtertagf = val;
    if(val == "date"){
        this.searchTagInit.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.searchTagInit.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }
  

  dataMap(data: any, first = null) {

    var strId = data['project']['@id']; 
    var splittedID = strId.split("/"); 
    var idProject = splittedID[splittedID.length-1];  
    var listTag : any[] = data['tags'];
    var date = data['dateCreated'];
    var smartNumber = data['smartNumber'];
    var answerDate = data['motionAt']; 
    //var isNewDay = this.isNewDay(date);

    var typeMessage = 'QUESTION';

    if (data['type'] == 'QUESTION') {
      typeMessage = 'Question';
    }
    else if (data['type'] == 'COMMENT'){
      typeMessage = 'Commentaire';
      smartNumber = data['number'];
    }
    else if (data['type'] == 'ANSWER'){
      typeMessage = 'Réponse';
    }

    const message: any = {
      'id': idProject,
      'project': data['project'],
      'first': first,
      'tag': (listTag[0] ? listTag[0].libelle  : '' ),
      'date': date,
      "answerDate": answerDate,
      'typeParse': typeMessage,
      'type': data['type'],
      'private': data['isPrivate'],
      'isGeneral': data['isGeneral'],
      'isThematic': data['isThematic'],
      'isTask': data['isTask'],
      'sender': (data['author'] ? data['author'] : ''),
      'recipient': (data['recipient'] ? data['recipient'] : ''),
      'copy': (data['copy'] ? data['copy'].length : ''),
      'read': data['isReadAnswer'],
      'deadline': data['deadline'],
      'number': data['number'],
      'smartNumber': smartNumber,
      'parentItem': data['parentItem'],
      'filegeneric': data['filegeneric'],
      'isMessageDisabled': data['isMessageDisabled'],
      'isMessageAnswered': data['isMessageAnswered'],
      //'isNewDay' : isNewDay,
      'color' : this.getDeadlineColor(data)
    };

    return message;
  }

  getDeadlineColor(element: any){

    if(element.type === 'QUESTION' && !element.isTask && !element.isThematic && !element.isGeneral) {
      if(element.isMessageAnswered) return '#57b031';
      else return '#e53935';
    } else if(element.type === 'QUESTION' && element.isTask && !element.isThematic && !element.isGeneral){
      if(element.isMessageAnswered) return '#57b031';
      else if(!element.isMessageAnswered && !this.getStatut(element).isDepasse && !element.isMessageDisabled) return '#5e93bf';
      else if(!element.isMessageAnswered && this.getStatut(element).isDepasse && !element.isMessageDisabled) return '#e53935';
      else if(element.isMessageDisabled) return '#888';
      else return '#333';
    }
  }

  getMessagesColor(){

    switch (this.statusMsg) {
      case 'Répondus':
        return '#58af31';

      case 'Non répondus':
        return '#e53935';
      
      case 'Annulés':
        return '#888';

      default:
        return '#000';
    }
  }

  getTasksColor(){

    switch (this.statusMsg) {

      case 'Échéance non dépassée':
        return '#5e93bf';

      case 'Échéance dépassée':
        return '#e53935';

      case 'Terminées':
        return '#58af31';

      case 'Annulées':
        return '#888';

      default:
        return '#000';
    }
  }

  getstatusColor(){

    switch (this.statusMsg) {
      case 'Répondus':
        return '#58af31';

      case 'Non répondus':
        return '#e53935';

      case 'Échéance non dépassée':
        return '#5e93bf';

      case 'Échéance dépassée':
        return '#e53935';

      case 'Terminées':
        return '#58af31';

      case 'Annulées':
        return '#888';
      
      case 'Annulés':
        return '#888';

      default:
        return '#000';
    }
  }

 public getAllMessagesSuivi(searchChoose) {

    this.paginator.pageIndex = 0;
    this.filterChoosen = searchChoose;
    console.log("getAllMessagesSuivi before merged")

    merge(this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          console.log("getAllMessagesSuivi merged")
          return this.authService.getAllMessagesSuivi(this.paginator.pageIndex, this.perPage, this.filterChoosen);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;    

          this.resultsLength = data['hydra:totalItems']; 
          if(this.typenotif == "sent") this.sentNotif = this.resultsLength;
          else if(this.typenotif == "incopy") this.incopyNotif = this.resultsLength;
          else if(this.typenotif == "received") this.receivedNotif = this.resultsLength;
          else if(this.typenotif == "comment") this.commentNotif = this.resultsLength;
          this.searchresLength = 0;

          return data['hydra:member'];
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => { 
        //console.log({test1111:data})
        //console.log('contenu de data '+ JSON.stringify(data));
        this.messages = [];
        this.lastDate = new Date('01/01/4970');
        data=data.filter(item=>!item.action);
        var j = 0;
        var first = false;
        data.forEach(element => {
          j++;
          if (j == 1) first = true;
          this.messages.push(this.dataMap(element, first));
          first = false;
        });

        this.dataSource = this.messages;
        this.buildGroups();
         

      });
      /*
      merge(this.refreshSearchObs)
      .pipe(
        startWith({}),
        switchMap(() => {
          console.log("getAllMessagesSuivi switch merged")
          return this.authService.getAllMessagesSuivi(this.paginator.pageIndex, this.perPage, this.filterChoosenSearch);
        }),
        map(data => {
          this.targetValue = data['hydra:totalItems'];
        }),
        catchError(() => {    
          return observableOf([]);
        })
      ).subscribe(data => {    
        if(this.checkSearchInit()) this.animateToValue(0);
        else this.animateToValue(this.targetValue);

      });*/

  }
  groupedData: { dateKey: string; date: Date; isToday: boolean; isYesterday: boolean; items: any[] }[] = [];

  private buildGroups(): void {
    const map = new Map<string, any>();
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const sameDay = (a: Date, b: Date) =>
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();

    (this.dataSource || []).forEach(element => {
      const d = new Date(element.date);
      const key = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;

      if (!map.has(key)) {
        map.set(key, {
          dateKey: key,
          date: element.date,
          isToday: sameDay(d, today),
          isYesterday: sameDay(d, yesterday),
          items: []
        });
      }
      map.get(key).items.push(element);
    });

    this.groupedData = Array.from(map.values());
  }

  isRoundFirst(afterIsNewDay, isNewDay){
    if(afterIsNewDay && isNewDay){
      return "divcontaine afterIsNewDayBL afterIsNewDayTL";
    }else if(afterIsNewDay){
      return "divcontaine afterIsNewDayBL";
    }else if(isNewDay){
      return "divcontaine afterIsNewDayTL";
    }
    return "divcontaine";
  }

  isRoundLast(afterIsNewDay, isNewDay){
    if(afterIsNewDay && isNewDay){
      return "divcontaine afterIsNewDayBR afterIsNewDayTR";
    }else if(afterIsNewDay){
      return "divcontaine afterIsNewDayBR";
    }else if(isNewDay){
      return "divcontaine afterIsNewDayTR";
    }
    return "divcontaine";
  }

  isNewDay(messageDate){
    let currentDate = new Date(messageDate.substring(0,10)); 
    //console.log('this.lastDate ==> '+this.lastDate);
    //console.log('currentDate ==> '+currentDate);
    if(currentDate < this.lastDate)
    {
      // console.log('Une section ==> '+ currentDate);
      this.lastDate = currentDate;
      return true;
    } 
    else
    { 
      this.lastDate = currentDate; 
      return false;
    }
  }

  getReceiver(recipientid){
    if(this.projectId){
      this.authService.getContactsRecipID(this.projectId, this.tag, this.transmitter).subscribe(res => {
        var tmpArrayUser = res['hydra:member'];
        this.contactsDest = [];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].id){
            this.contactsDest.push(tmpArrayUser[i]);
          }
        }
        this.contactsDest.sort(this.compare);
        this.searchRecipientInit = this.contactsDest;
      }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
      });
    } else {
      this.authService.getAllRecipientsBySender(recipientid).subscribe(res => {
        var tmpArrayUser = res['hydra:member'];
        this.contactsDest = [];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].id){
            this.contactsDest.push(tmpArrayUser[i]);
          }
        }
        this.contactsDest.sort(this.compare);
        this.searchRecipientInit = this.contactsDest;
      }, (error) => {
        //console.log(' getTheProject subscribe error '+error.statusText);
      });
    }
  }

  getContact(recip = false){
    //this.loadContact();

    this.authService.getContactsExpID(this.projectId, this.tag, this.isThematic, this.isGeneral).subscribe(res => {
      this.contactsExp = [];
      var tmpArrayUser = res['hydra:member'];
      for (var i = 0; i < tmpArrayUser.length; i++) {
        this.contactsExp.push(tmpArrayUser[i]);
      }
      this.contactsExp.sort(this.compare);
      this.searchSenderInit = this.contactsExp;
    }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
    });
    if(recip == false){
      this.authService.getContactsRecip().subscribe(res => {
        this.contactsDest = [];
        var tmpArrayUser = res['hydra:member'];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          this.contactsDest.push(tmpArrayUser[i]);
        }
        this.contactsDest.sort(this.compare);
        this.searchRecipientInit = this.contactsDest;
      }, (error) => {
          //console.log(' getTheProject subscribe error '+error.statusText);
      });
    }

  }

  /*loadContact(url?: string){
    url = url ? url : undefined;
    this.authService.getContacts(url).subscribe(res => {
      this.contacts = this.contacts.concat(res['hydra:member']);
      
      if(this.contacts.length && this.contacts[0].id != this.currentUser.id){
        this.contacts.unshift(this.currentUser);
      }
      this.contacts.sort(this.compare);

      if(res['hydra:view']['hydra:next']){
        this.loadContact(res['hydra:view']['hydra:next'].replace("/api", ""));
      }
    }); 
  }*/

  compare( a, b ) {
    if ( a.givenName.toLowerCase() < b.givenName.toLowerCase() ){
      return -1;
    }
    if ( a.givenName.toLowerCase() > b.givenName.toLowerCase() ){
      return 1;
    }
    return 0;
  }

  loadTypes(url?: string){
    this.searchtypesApi = [];
    this.authService.getMessageTypes(this.projectId, this.transmitter, this.recipient, null, this.tag).subscribe(res => {
      this.searchtypesApi = this.searchtypesApi.concat(res['hydra:member']);
      this.searchtypes = this.searchtypesfilter.filter(item => this.searchtypesApi.includes(item.id));
    }); 
  }

  loadTypesBlocs(url?: string){
    this.searchtypesblocs = [];
    this.authService.getMessageBlocTypes(this.projectId, this.transmitter, this.recipient, null, this.tag).subscribe(res => {
      var result = this.searchtypesApi.concat(res['hydra:member']);
      const order = { 'face': 0, 'team': 1, 'general': 2 };
      result.sort((a, b) => order[a] - order[b]);
      this.searchtypesblocs = result;
    }); 
  }

  loadProject(url?: string){
    url = url ? url : undefined;
    this.authService.getProjectsMessages().subscribe(res => {
      this.projectLists = this.projectLists.concat(res['hydra:member']);
      /*
      this.projectLists = this.projectLists.sort(function (a, b) {
          if (a.libelle.toLowerCase() < b.libelle.toLowerCase()) { return -1; }
          if (a.libelle.toLowerCase() > b.libelle.toLowerCase()) { return 1; }
          return 0;
      })
      if(res['hydra:view']['hydra:next']){
        this.loadProject(res['hydra:view']['hydra:next'].replace("/api", ""));
      }*/
      this.projectInit = this.projectLists;
      this.projectInit.forEach(project => {
        project.randomColor = this.getRandomColor();
      });
    }); 
  }

  getSujet(idProject){
    this.projectId = idProject;
    this.searchTags = [];
    this.authService.getTagsByProject(idProject, this.isThematic, this.isGeneral).subscribe(res => {
      this.searchTags = this.searchTags.concat(res['hydra:member']);
      this.searchTagInit = this.searchTags;
    }, (error) => {
       //console.log(' getTheProject subscribe error '+error.statusText);
    });
  }


  search(){
    if(this.modeDoc){
      this.launchSearchDoc()
    }else{
      this.launchSearch()
    }
  }
  
  launchSearch(ged = null){
    this.modeDoc = false;
    //if(!ged) this.hiddenSearchEngin = true;
    if((this.dateDeadline != null || this.dateDeadlineAfter != null) && (this.statut == null)){
      /*
      alert("statut "+this.statut)
      this.statut = false;
      this.chosenFilter.statut = false;*/
      this.chosenFilter = { 
        transmitter: this.transmitter,
        recipient: this.recipient,
        projectId: this.projectId,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        dateDeadline: this.dateDeadline,
        dateDeadlineAfter: this.dateDeadlineAfter,
        tag: this.tag,
        statut: false, 
        copy: this.copy,
        type: this.type,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber,
        isGeneral: this.isGeneral,
        isThematic: this.isThematic,
        isTask: this.isTask
      };
    } else {
      this.chosenFilter = { 
        transmitter: this.transmitter,
        recipient: this.recipient,
        projectId: this.projectId,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        dateDeadline: this.dateDeadline,
        dateDeadlineAfter: this.dateDeadlineAfter,
        tag: this.tag,
        statut: this.statut, 
        copy: this.copy,
        type: this.type,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber,
        isGeneral: this.isGeneral,
        isThematic: this.isThematic,
        isTask: this.isTask
      };
    }
    //alert("this "+this.statut)
    /*
    this.chosenFilter = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateAfter: this.dateAfter,
      dateDeadline: this.dateDeadline,
      dateDeadlineAfter: this.dateDeadlineAfter,
      tag: this.tag,
      statut: this.statut, 
      type: this.type,
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber
    };*/
    
    //this.getAllMessages(this.chosenFilter)
    //console.log(' launchSearch '+ JSON.stringify(this.chosenFilter) );
    //this.fcthiddenSearchEngin();
    this.EventLaunchSearch.emit(this.chosenFilter);

  }

  filterMessageCount(ged = null){

    //this.modeDoc = false;
    //if(!ged) this.hiddenSearchEngin = true;
    if((this.dateDeadline != null || this.dateDeadlineAfter != null) && (this.statut == null)){
      /*
      alert("statut "+this.statut)
      this.statut = false;
      this.chosenFilter.statut = false;*/
      this.filterChoosenSearch = { 
        transmitter: this.transmitter,
        recipient: this.recipient,
        projectId: this.projectId,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        dateDeadline: this.dateDeadline,
        dateDeadlineAfter: this.dateDeadlineAfter,
        tag: this.tag,
        statut: false,
        copy: this.copy, 
        type: this.type,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber,
        isGeneral: this.isGeneral,
        isThematic: this.isThematic,
        isTask: this.isTask
      };
    } else {
      this.filterChoosenSearch = { 
        transmitter: this.transmitter,
        recipient: this.recipient,
        projectId: this.projectId,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        dateDeadline: this.dateDeadline,
        dateDeadlineAfter: this.dateDeadlineAfter,
        tag: this.tag,
        statut: this.statut, 
        copy: this.copy, 
        type: this.type,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber,
        isGeneral: this.isGeneral,
        isThematic: this.isThematic,
        isTask: this.isTask
      };
    }
    this.refreshSearchObs.next();

  }

  animateToValue(newValue: number) {
    if (newValue == this.searchresLength) return;
  
    const step = newValue > this.searchresLength ? 1 : -1;
  
    // Durée totale de l'animation (ici 1 seconde, à ajuster si nécessaire)
    const animationDuration = 1000; // 1000 ms = 1 seconde
    const totalSteps = Math.abs(newValue - this.searchresLength); // nombre d'incréments nécessaires
    const stepDuration = animationDuration / totalSteps; // durée de chaque incrément
  
    let startTime = performance.now(); // Horodatage au début de l'animation
    let lastStepTime = startTime; // Temps du dernier "step" effectué
    let currentStep = 0; // Compteur des étapes réalisées
  
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime; // Temps écoulé depuis le début de l'animation
      const progress = Math.min(elapsed / animationDuration, 1); // Calcul du progrès de l'animation
  
      // Nombre d'étapes réalisées jusqu'à maintenant, basé sur le temps écoulé
      currentStep = Math.floor(progress * totalSteps);
  
      // Si une nouvelle étape doit être effectuée
      if (currentTime - lastStepTime >= stepDuration) {
        this.searchresLength = this.searchresLength + step;
        lastStepTime = currentTime; // Mettre à jour le temps du dernier step
  
        // Si la cible est atteinte, on s'assure que la valeur finale est atteinte
        if ((step === 1 && this.searchresLength >= newValue) || (step === -1 && this.searchresLength <= newValue)) {
          this.searchresLength = newValue;
        }
      }
  
      // Si l'animation n'est pas encore terminée, on continue l'animation
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // À la fin de l'animation, on s'assure que la valeur finale est bien celle attendue
        this.searchresLength = newValue;
      }
    };
  
    // Démarre l'animation
    requestAnimationFrame(animate);
  }

  openProfilDialog() {
    this.dialog.closeAll();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'contactpanel';
    dialogConfig.id = 'balchal718';
    dialogConfig.width = '550px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = { name: this.name, profile: this.profile, commonRef: this.commonRef };
    //const dialogRef = this.dialog.open(ProfileComponent, dialogConfig);
    const dialogRef = this.dialog.open(ProfileComponent, {
      data: { name: this.name, profile: this.profile, commonRef: this.commonRef },
      panelClass: 'transferclass',
      backdropClass: 'custom-backdrop'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
    });

  }

  launchSearchDoc(){
    if(this.type=="http") {
      alert("Vous ne pouvez pas sélectionner le type lien pour rechercher un document");
      return;
    }
    this.modeDoc = true;

    this.chosenFilter = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateDeadline: this.dateDeadline,
      dateDeadlineAfter: this.dateDeadlineAfter,
      dateAfter: this.dateAfter,
      tag: this.tag,
      statut: this.statut,
      type: this.type, 
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber
    };
    this.fcthiddenSearchEngin();
    this.EventLaunchSearchDoc.emit(this.chosenFilter);

  }

  checkSearchInit(){
    if(this.projectId == null && this.transmitter == null && this.recipient == null && this.dateBefore  == null && this.dateAfter  == null && this.dateDeadline == null && this.dateDeadlineAfter == null && this.tag == null && this.statut == null && this.type == null && this.keyWord == null && this.smartNumber == null && this.isGeneral == null && this.isThematic == null){
      return true;
    } else {
      return false;
    }
  }

  public resetSearch(){

    this.transmitter = null;
    this.recipient = null;
    this.projectId = null;
    this.dateBefore  = null;
    this.dateAfter  = null;
    this.dateDeadline = null;
    this.dateDeadlineAfter = null;
    this.tag = null;
    this.statut = null;
    this.copy = null;
    this.type = null;
    this.keyWord = null;
    this.smartNumber = null;
    this.typebloc = null;
    this.isGeneral = null;
    this.isThematic = null;
    this.isTask = null;
    this.launchSearch("1");
    this.resetSearchFace();

    /*
    if(this.modeDoc == false) 
    {
      this.launchSearch();
    }
    else
    {
      this.launchSearchDoc();
    }*/
    this.getContact();
    //this.getMessageStatus();

  }
  
  getSubject(subject){
    if(subject === "Thématique d'échange"){
      return "Thèmatique";
      } else return subject;
  }

  getMessageStatus(){
  }
  
  initProjectFace(item = null){
    this.searchproject = "Client";
    this.projectId = null; 
    //this.initRecipientFace('1');
    //this.getReceiver(null);
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    this.initTagFace('1');
    this.initSenderFace('1');
    this.getContact();
    this.initRecipientFace('1');
    this.getReceiver(null);
    //this.initStatusFace('1');
    this.initTypeFace('1');
    this.initTypeBloc('1');
    this.loadTypes();
    //this.getMessageStatus();
  }
  
  initSenderFace(item = null){
    this.searchsenderface = "Expéditeur";
    this.transmitter = null; 
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    this.initRecipientFace('1');
    this.getReceiver(null);
    //this.initStatusFace('1');
    this.initTypeFace('1');
    this.loadTypes();
    //this.getMessageStatus();
  }

  initRecipientFace(item = null){
    this.searchrecipientface = "Destinataire";
    this.recipient = null;
    //this.getMessageStatus();
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    //this.initStatusFace('1');
    this.initTypeFace('1');
    this.loadTypes();
    //this.getMessageStatus();
  }

  initTypeFace(item = null){
    this.searchtypeface = "Type de Document";
    this.type = null;
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  initTypeBloc(item = null){
    this.searchtypebloc = "Type de bloc";
    this.typebloc = null;
    this.isGeneral = null;
    this.isThematic = null;
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  initTagFace(item = null){
    this.searchthemeface = "Canal";
    this.tag = null;
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    this.initSenderFace('1');
    this.getContact(true);
    this.initRecipientFace('1');
    this.getReceiver(null);
    //this.initStatusFace('1');
    this.initTypeFace('1');
    this.loadTypes();
    //this.getMessageStatus();
  }

  initStatusFace(item = null){
    this.searchstatusface = "Statut des faces";
    this.statut = null;
    this.initProjectFace('1');
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  selectChoiceFace(item = "init"){
    if(this.searchstepface == "init" && item == "init") {
      this.fcthiddenSearchEngin();
    } else this.searchstepface = item;
  }

  selectProject(libelle, id){
    this.searchproject = libelle;
    this.projectId = id;
    this.loadFilterElement();
    this.getSujet(id);
    this.selectChoiceFace("init");
    this.filterMessageCount();
    this.getContact(true);
    this.getReceiver(null);
    //this.getMessageStatus();
  }

  selectSenderFace(givenname, familyname, id){
    this.searchsenderface = givenname + familyname;
    this.transmitter = id;
    this.selectChoiceFace("init");
    this.filterMessageCount();
    this.getReceiver(id);
    //this.getMessageStatus();
  }

  selectRecipientFace(givenname, familyname, id){
    this.searchrecipientface = givenname + familyname;
    this.recipient = id;
    this.selectChoiceFace("init");
    this.filterMessageCount();
    //this.getMessageStatus();
  }

  /*
  selectCopyFace(givenname, familyname, id){
    this.searchcopyface = givenname + familyname;
    this.copy = id;
    this.selectChoiceFace("init");
  }*/

  selectTypeFace(libelle, id){
    this.searchtypeface = libelle;
    this.selectChoiceFace("init");
    this.type = id;
    this.filterMessageCount();
  }

  selectTypeBloc(libelle){
    this.searchtypebloc = libelle;
    if(libelle == 'face'){
      this.isGeneral = false;
      this.isThematic = false;
    } else if(libelle == 'team'){
      this.isGeneral = true;
      this.isThematic = true;
    } else if(libelle == 'general'){
      this.isGeneral = true;
      this.isThematic = false;
    }
    this.selectChoiceFace("init");
    this.getSujet(this.projectId);
    this.typebloc = libelle;
    this.filterMessageCount();
  }

  selectStatusFace(libelle, item, type = null){
    this.statut = item;
    this.searchstatusface = libelle;
    this.isGeneral = false;
    this.isThematic = false;
    if(item == 'false' && type == 'copy') {
      this.copy = this.currentUser.id;
      this.initSenderFace('1');
      this.selectChoiceFace("init");
      this.filterMessageCount();
    } else if(type == 'mine') {
      this.copy = null;
      this.selectSenderFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    } else if(type == 'received') {
      this.copy = null;
      this.searchsenderface = "Éxpéditeur";
      this.transmitter = null; 
      this.getReceiver(null);
      this.selectRecipientFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    } else if(type == 'true') {
      this.copy = null;
      this.selectSenderFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    } else {
      this.copy = null;
      this.selectSenderFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    }
  }

  onFilterChange(value: string) {
    this.statusMsg = null;
    this.statut = null;
    this.dateDeadline = null;
    this.isThematic = null;
    this.isGeneral = null;
    if(value === 'all'){
        this.isTaskMode = null;
        this.showStatutMenu = false;
        this.activeSubMenu = null;
      } else if(value === 'message'){
        this.isTaskMode = false;
      } else this.isTaskMode = true;
    this.selectDefaultStatusFace(this.typenotif, this.isTaskMode)
  }
 

goToPage(page: number) {
  if (page < 1 || page > Math.ceil(this.resultsLength / this.perPage)) return;
  this.currentPage = page;
  this.paginator.pageIndex = page - 1; // MatPaginator est 0-indexé
  this.paginator.page.emit({
    pageIndex: page - 1,
    pageSize: this.perPage,
    length: this.resultsLength
  });
  if(this.journalWrapper && this.journalWrapper.nativeElement) this.journalWrapper.nativeElement.scrollIntoView({block: "start"});
  //document.getElementById('journalWrapper')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

getPageNumbers(): (number | string)[] {
  const total = Math.ceil(this.resultsLength / this.perPage);
  const current = this.currentPage;
  const pages: (number | string)[] = [];

  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
    return pages;
  }

  pages.push(1);
  if (current > 3) pages.push('...');

  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i++) pages.push(i);

  if (current < total - 2) pages.push('...');
  pages.push(total);

  return pages;
}
  /*
  filterStatusMessages(libelle = 'status', answered = null){
    this.statusMsg = libelle;
    if(answered == null){
      this.isThematic = false;
      this.isGeneral = false;
      this.statut = null;
    }
    if(answered == 'answered' || answered == 'finished') this.statut = true;
    else if(answered == 'notanswered' || answered == 'inprogress') {
      this.statut = false;
      this.isThematic = false;
      this.isGeneral = false;
    } else if(answered == 'cancelled' || answered == 'archived') this.statut = false;
    this.selectDefaultStatusFace(this.typenotif, this.isTaskMode)
  }*/

  filterStatusMessages(libelle = 'status', answered = null, isTaskMode = null){
    this.isTaskMode = isTaskMode;
    this.statusMsg = libelle;
    this.statut = null;
    this.dateDeadline = null;
    this.dateDeadlineAfter = null;
    this.isThematic = null;
    this.isGeneral = null;
    if(answered == null){
      this.isThematic = false;
      this.isGeneral = false;
      this.statut = null;
    }
    if(answered == 'answered' || answered == 'finished') {
      this.statut = true;
      this.isGeneral = false;
      this.isThematic = false;
    } else if(answered == 'notanswered') {
      this.statut = false;
      this.isThematic = false;
      this.isGeneral = false;
    } else if(answered == 'inprogress') {
      this.statut = false;
      this.isThematic = false;
      this.dateDeadlineAfter = new Date();
      this.isGeneral = false;
    } else if (answered == 'depassed'){
      this.dateDeadline = new Date();
      console.log("isss depassed")
      this.statut = false;
    }
    this.showStatutMenu = false;
    this.activeSubMenu = null;
    this.filtreMessageBystatus(this.typenotif, this.isTaskMode);
  }

  filtreMessageBystatus(type = null, isTask = null){
    //this.statut = item;
    console.log("tyype : "+type)
    this.typenotif = type;
    var task = null;
    if(isTask != null) task = isTask;
    if(type == 'incopy') {
      this.transmitter = null;
      this.recipient = null;
      this.copy = this.currentUser.id;
      //this.launchSearch();
      //this.filterMessageCount();
    } else if(type == 'sent') {
      this.copy = null;
      this.recipient = null;
      this.isReadAnswer = false;
      this.transmitter = this.currentUser.id;
      //this.launchSearch();
      //this.selectSenderFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    } else if(type == 'received') {
      this.copy = null;
      this.statut = 'false';
      this.transmitter = null; 
      this.recipient = this.currentUser.id;
      this.isGeneral = false;
      this.isThematic = false;
    } else if(type == 'comment') {
      this.copy = this.currentUser.id;
      this.statut = "comment";
      this.recipient = null;
      this.transmitter = null;
      //this.launchSearch();
      //this.selectSenderFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    }
      console.log("isss2 depassed")
    this.chosenFilter = { 
        transmitter: this.transmitter,
        recipient: this.recipient,
        projectId: this.projectId,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        dateDeadline: this.dateDeadline,
        dateDeadlineAfter: this.dateDeadlineAfter,
        tag: this.tag,
        statut: this.statut, 
        copy: this.copy,
        type: this.type,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber,
        isGeneral: this.isGeneral,
        isThematic: this.isThematic,
        isTask: task,
        isReadAnswer: this.isReadAnswer
    };
    console.log("getAllMessagesSuivi status fil")
    this.getAllMessagesSuivi(this.chosenFilter)
  }

  selectDefaultStatusFace(type = null, isTask = null){
    //this.statut = item;
    console.log("tyype : "+type)
    this.typenotif = type;
    this.isGeneral = null;
    this.isThematic = null;
    var task = null;
    if(isTask != null) task = isTask;
    if(type == 'incopy') {
      this.transmitter = null;
      this.recipient = null;
      this.copy = this.currentUser.id;
      this.statut = null;
      //this.launchSearch();
      //this.filterMessageCount();
    } else if(type == 'sent') {
      this.copy = null;
      this.statut = null;
      this.recipient = null;
      this.isReadAnswer = false;
      this.transmitter = this.currentUser.id;
      this.isGeneral = false;
      this.isThematic = false;
      //this.launchSearch();
      //this.selectSenderFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    } else if(type == 'received') {
      this.copy = null;
      this.statut = 'false';
      this.transmitter = null; 
      this.recipient = this.currentUser.id;
      this.isGeneral = false;
      this.isThematic = false;
    } else if(type == 'comment') {
      this.copy = this.currentUser.id;
      this.statut = "comment";
      this.recipient = null;
      this.transmitter = null;
      //this.launchSearch();
      //this.selectSenderFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    }
    console.log("staaaa : "+this.statut)
    this.chosenFilter = { 
        transmitter: this.transmitter,
        recipient: this.recipient,
        projectId: this.projectId,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        dateDeadline: this.dateDeadline,
        dateDeadlineAfter: this.dateDeadlineAfter,
        tag: this.tag,
        statut: this.statut, 
        copy: this.copy,
        type: this.type,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber,
        isGeneral: this.isGeneral,
        isThematic: this.isThematic,
        isTask: task,
        isReadAnswer: this.isReadAnswer
    };
    console.log("getAllMessagesSuivi select def")
    this.getAllMessagesSuivi(this.chosenFilter)
  }
  
  selectThemeFace(libelle, id){
    this.searchthemeface = libelle;
    this.tag = id;
    this.initSenderFace('1');
    this.initRecipientFace('1');
    this.selectChoiceFace("init");
    this.filterMessageCount();
    this.getContact();
    this.getReceiver(null);
  }

  onDateBeforChange(newDate: any): void {
    this.dateBefore = newDate;
    this.filterMessageCount();
  }

  onDateAfterChange(newDate: any): void {
    this.dateAfter = newDate;
    this.filterMessageCount();
  }

  onDeadlineBeforChange(newDate: any): void {
    this.dateDeadline = newDate;
    this.filterMessageCount();
  }

  onDeadlineAfterChange(newDate: any): void {
    this.dateDeadlineAfter = newDate;
    this.filterMessageCount();
  }

  resetSearchFace(){
    this.searchproject = "Client";
    this.searchtypeface = "Type de Document";
    this.searchtypebloc = "Type de bloc";
    this.searchsenderface = "Éxpéditeur";
    this.searchrecipientface = "Destinataire";
    this.searchcopyface = "Membre en Copie";
    this.searchthemeface = "Canal";
    this.searchtypeface = "Type de Document";
    this.searchdateface = "Face";
    this.searchstatusface = "Statut des faces";
    this.searchnumface = "Numéro du face";
  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  getProjectImage(avatarLink){
    return environment.server_url+"/media/project_img/"+avatarLink;
  }

  getContactImage(avatarLink){
    return environment.server_url+"/media/profil/"+avatarLink;
  }


  public refreshInfoFilter(){
    this.getContact();
    this.loadProject();  
  }

  goBack(){
    this.location.back();
    //this.router.navigate(['/project/'+this.recentProject]);
    //window.history.back();
  }




}



